import React from "react";
import "../ManualDeliveries.css";

// One persistent toast. The live region is always mounted so a new toast is announced; it stays until dismissed.
// besidePanel: the New delivery panel is open, so the region moves clear of it (left of it, or to the top on a
// narrow screen) instead of covering its footer notice and price hold. It stays outside the panel's layer.
export default function Toast({ toast, onDismiss, besidePanel = false }) {
  const className = besidePanel ? "md-toast-region md-toast-region--beside-panel" : "md-toast-region";
  return (
    <div role="status" aria-live="polite" className={className}>
      {toast ? (
        <div className="md-toast">
          <div className="md-toast__text">
            <span className="md-toast__title">{toast.title}</span>
            {toast.text ? <span className="md-toast__sub">{toast.text}</span> : null}
          </div>
          {toast.action ? (
            <button type="button" className="md-toast__action" onClick={toast.action.run}>
              {toast.action.label}
            </button>
          ) : null}
          <button type="button" className="md-toast__close" aria-label="Dismiss" onClick={onDismiss}>
            ×
          </button>
        </div>
      ) : null}
    </div>
  );
}
